import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
          <div>
            <img src={logo} alt="Kushi Fashions" className="h-12 w-auto mb-2" />
            <p className="text-xs text-gray-500">Your favourite destination for elegant dresses.</p>
          </div>
          <div>
            <h4 className="text-white text-xs font-semibold mb-2 uppercase tracking-wider">Shop</h4>
            <ul className="space-y-1 text-xs">
              <li><Link to="/products" className="hover:text-primary-400 transition-colors">All Products</Link></li>
              <li><Link to="/products?category=kurta" className="hover:text-primary-400 transition-colors">Kurtas</Link></li>
              <li><Link to="/products?category=saree" className="hover:text-primary-400 transition-colors">Sarees</Link></li>
              <li><Link to="/products?category=western" className="hover:text-primary-400 transition-colors">Western Wear</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-xs font-semibold mb-2 uppercase tracking-wider">Account</h4>
            <ul className="space-y-1 text-xs">
              <li><Link to="/login" className="hover:text-primary-400 transition-colors">Login</Link></li>
              <li><Link to="/register" className="hover:text-primary-400 transition-colors">Register</Link></li>
              <li><Link to="/orders" className="hover:text-primary-400 transition-colors">My Orders</Link></li>
              <li><Link to="/wishlist" className="hover:text-primary-400 transition-colors">Wishlist</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-xs font-semibold mb-2 uppercase tracking-wider">Help</h4>
            <ul className="space-y-1 text-xs">
              <li><Link to="/support" className="hover:text-primary-400 transition-colors">Support Center</Link></li>
              <li><Link to="/support" className="hover:text-primary-400 transition-colors">Return Policy</Link></li>
              <li><a href="mailto:support@kushifashions.com" className="hover:text-primary-400 transition-colors">support@kushifashions.com</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-3 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-gray-600">© {new Date().getFullYear()} Kushi Fashions. All rights reserved.</p>
          <div className="flex items-center gap-1 text-xs text-gray-600">
            <span>Secure payments by</span>
            <span className="text-primary-400 font-semibold">Razorpay</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
